export const getHashUserLoginId = () => {
    let hashUserLoginId = localStorage.getItem('hashUserLoginId');

    if (!hashUserLoginId) {
        hashUserLoginId = crypto.randomUUID();
        localStorage.setItem('hashUserLoginId', hashUserLoginId);
    }

    return hashUserLoginId;
};
